import React, { useEffect, useRef, useState, useCallback } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";
import "primeicons/primeicons.css";
import { ApiEndpoints, Constants } from "../../constants/appConstants";
import { useLocation, useSearchParams } from "react-router";
import httpService from "../../services/httpService";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
//import { useNavigate } from 'react-router';
import "./ProviderProfileComponent.scss";
import { Tooltip } from "primereact/tooltip";
import ProviderProfileTooltip from "./ProviderProfileTooltip";
import { Badge } from "primereact/badge";
import {
  alphaNumericSort,
  PerformanceArea,
  ReviewRquest,
  Standard,
  TierQuestions,
  Status,
  ReviewStatusCode,
  Comment,
  ReviewType,
  TierCode,
  ProviderType,
  ReviewState,
} from "./models";
import StandardsDetailsComponent from "./StandardsDetailsComponent";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useAuthContext } from "../../Context/AuthContext";
import CommentsSidebar from "./CommentsSidebar";
import { useAppContext } from "../../Context";
import MultipartFileUploadComponent from "../FileUpload/MultpartFileUploadComponent";
import CommonDialogWindowComponent from "../CommonDialogWindowComponent/CommonDialogWindowComponent";
import SmeReviewStatsComponent from "./SmeReviewStatsComponent";
import ReviewStageTrackerComponent from "./ReviewStageTrackerComponent";
import type { StageReviewer, ReviewActivityLog } from "./ReviewStageTrackerComponent";
import SendEmailDialogComponent from "./SendEmailDialogComponent";
import ProviderCommentIcon from "./ProviderCommentIcon";

const ScoProviderProfileComponent: React.FC<{ reviewYear?: number }> = ({ reviewYear: propReviewYear }) => {
  //const navigate = useNavigate()
  const { appUser, isAdministrator, isFinalReviewer, isSmeReviewer } =
    useAuthContext();
  const [uploadStatus, setUploadStatus] = useState<string | null>(null);
  const location = useLocation();
  const [provider, setSelectedProvider] = useState<any>({});
  const [providerContactDetails, setProviderContactDetails] = useState<any>({});
  //const [providerDetails, setProviderDetails] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [fileUploaded, setFileUploaded] = useState<boolean>(false); // New state to track file upload status
  //const [activeIndex] = useState<number[]>([0, 1, 2]);
  const [status, setStatus] = useState<Status[]>([]);
  const [performanceAreas, setPerformanceAreas] = useState<PerformanceArea[]>(
    []
  ); // New state to hold performance areas
  const [visible, setVisible] = useState(false);
  const [reviweResponses, setReviewResponses] = useState<ReviewRquest[]>([]);
  const [calculatedTier, setCalculatedTier] = useState<string>();
  const [isCalculate, setIsCalculate] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    Status | null | undefined
  >(null);
  const [isActiveReview, setIsActiveReview] = useState(false);
  const [isActiveDisputeReview, setIsActiveDisputeReview] = useState(false);
  const [appliedTierId, setAppliedTierId] = useState<number>(0);
  const [allStatues, setAllStatues] = useState<Status[]>([]);
  const [isStatusLoaded, setIsStatusLoaded] = useState<boolean>(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [commentProviderMPI, setCommentProviderMPI] = useState(
    location?.state?.provider?.mpi
  );
  const [commentMeasureNumber, setCommentMeasureNumber] = useState("");
  const [commentMeasureId, setCommentMeasureId] = useState(0);
  const [commentLevel, setCommentLevel] = useState("");
  const [providerId, setProviderId] = useState(0);
  const [allCommentData, setAllCommentData] = useState<Comment[]>([]);
  const [allProviderLevelCommentData, setAllProviderLevelCommentData] = useState<Comment[]>([]);
  const { reviewYear: contextReviewYear } = useAppContext();
  const reviewYear = propReviewYear ?? contextReviewYear;
  const [searchParams] = useSearchParams();
  const [providerAdditionalInfo, setProviderAdditionalInfo] = useState<any>({});
  const [statusesByRole, setStatusesByRole] = useState<any[]>([]);
  const [measureEvaluationStatuses, setMeasureEvaluationStatuses] = useState<
    any[]
  >([]);
  const [reviewers, setReviewers] = useState<any[]>([]);
  const [canReview, setCanReview] = useState<boolean>(false);
  const [canStartReview, setCanStartReview] = useState<boolean>(false);
  const [emailDialogVisible, setEmailDialogVisible] = useState<boolean>(false);
  // Reference variable for Dialog component
  const dialogRef = useRef<any>(null);
  // Reference variable for Toast component
  const toast = useRef<Toast>(null);
  // const [reviewReasons,setReviewReasons]=useState<any[]>();

  const [changingStatus, setChangingStatus] = useState<boolean>(false);
  const [updatingStatus, setUpdatingStatus] = useState<boolean>(false);

  useEffect(() => {
    getMeasureEvaluationStatuses();
    return () => {
      if (dialogRef.current) {
        dialogRef.current = null;
      }
    };
  }, []);

  const getMeasureEvaluationStatuses = () => {
    httpService
      .get(
        `${ApiEndpoints.GetMeasureEvaluationStatuses}?providerType=${ProviderType.SCO}`
      )
      .then((response: any) => {
        if (response.status === 200) {
          setMeasureEvaluationStatuses(response.data);
        }
      })
      .catch((error: any) => {
        console.error("ScoProviderProfileComponent.getMeasureEvaluationStatuses failed", error);
      });
  };

  useEffect(() => {
    if (canReview && reviewers && reviewers.length > 0) {
      let canStart = false;
      if (
        provider &&
        ![
          ReviewStatusCode.ScoNotStarted?.toLowerCase(),
          ReviewStatusCode.NotStarted?.toLowerCase(),
          ReviewStatusCode.ScoResolutionNotStarted?.toLowerCase()
        ].includes(provider.reviewStatusCode?.toLowerCase()) &&
        reviewers?.length > 0 &&
        statusesByRole.includes(provider.reviewStatusCode)
      ) {
        canStart = reviewers.some(
          (r: any) =>
            r.reviewStatusCode?.toLowerCase() ===
              provider.reviewStatusCode?.toLowerCase() &&
            (!r.reviewState ||
              r.reviewState?.toLowerCase() ===
                ReviewState.NOTSTART?.toLowerCase())
        );
      }

      setCanStartReview(canStart);
    }
  }, [provider, canReview, reviewers, statusesByRole]);

  // Initialize provider from location
  useEffect(() => {
    const mpiId = searchParams.get("mpi");
    if (reviewYear && !mpiId) {
      const _provider = location.state?.provider;
      if (_provider) {
        fetchProviderDetails(_provider?.mpi);
        fetchAllCommentsForProvider(_provider?.mpi);
        fetchAllCommentsForProviderLevel(_provider?.mpi);
        fetchProviderContactDetails(_provider?.mpi);
        setProviderId(_provider?.providerId);
        setCommentProviderMPI(_provider?.mpi);
        setCommentMeasureNumber(_provider?.mpi);
        getProviderAdditionalInfo(_provider?.mpi);
        setCommentMeasureId(0);
        setCommentLevel("provider");
        fetchStatusesByUser();
        getReviewersDetails(_provider?.mpi);
        canHaveAccessToReview(_provider?.mpi);
        //fetchProviderAttestationFileDetails(_provider?.mpi);
        // fetchPerformanceStandardsMeasuresInfo(
        //   _provider?.mpi,
        //   _provider?.appliedTier
        // );
      } // Fetch performance areas and related data
    }
  }, [location.state?.provider, reviewYear]);

  useEffect(() => {
    const mpiId = searchParams.get("mpi");

    if (reviewYear && mpiId) {
      //const mpi = Number(mpiId);
      //fetchProviderDetails(mpi);
      fetchProviderDetails(mpiId);
      fetchAllCommentsForProvider(mpiId);
      fetchAllCommentsForProviderLevel(mpiId);
      fetchProviderContactDetails(mpiId);
      getProviderAdditionalInfo(mpiId);
      getReviewersDetails(mpiId);
      canHaveAccessToReview(mpiId);
      setCommentProviderMPI(mpiId);
      setCommentMeasureNumber(mpiId);
      setCommentMeasureId(0);
      fetchStatusesByUser();
      setCommentLevel("provider");
    } // Fetch performance areas and related data
  }, [location.state?.provider, reviewYear, searchParams]);

  const fetchStatusesByUser = () => {
    httpService
      .get(`${ApiEndpoints.GetStatusesByRole}?providerType=${ProviderType.SCO}`)
      .then((response: any) => {
        if (response.status === 200) {
          setStatusesByRole(response.data);
        }
      })
      .catch((error: any) => {
        console.error("ScoProviderProfileComponent.fetchStatusesByUser failed", error);
      });
  };

  useEffect(() => {
    if (provider?.mpi) {
      setProviderId(provider?.providerId);
      const providerTierCode = provider?.appliedTierCode || provider?.currentTierCode;
      if (providerTierCode) {
        fetchPerformanceStandardsMeasuresInfo(provider.mpi, providerTierCode);
      }
    }
  }, [provider?.providerId, provider?.mpi, provider?.appliedTierCode, reviewYear, isActiveDisputeReview]);

  //onload events

  useEffect(() => {
    isActiveReviewCycle();
    isActiveDisputeReviewCycle();
    getAllStatus();
  }, []);

  useEffect(() => {
    if (provider.providerId && isStatusLoaded && !isActiveDisputeReview) {
      updateStatusDropDown();
      setSelectedStatus(getSelectedStatus(provider.reviewStatus));
    }
    else if(provider.providerId && isStatusLoaded && isActiveDisputeReview){
      updateStatusDropDownForDispute();
      setSelectedStatus(getSelectedStatus(provider.reviewStatus));
    }
  }, [provider, isStatusLoaded,isActiveDisputeReview]);

  useEffect(() => {
    if (
      appUser &&
      (isSmeReviewer() || isAdministrator()) &&
      provider &&
      reviewers &&
      reviewers.length > 0 &&
      ((isActiveDisputeReview && provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()) || provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoReviewCompleted.toLowerCase())
    ) {
      if (
        (isActiveDisputeReview && provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()  ) || 
        provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoFinalReview.toLowerCase()
      ) {
        changeStatusToFinalReview();
      }
    }
  }, [performanceAreas, changingStatus]);

  useEffect(() => {
    if (providerId > 0) {
      updatePerformanceAreasForComments(0, true);
    }
  }, [allCommentData, providerId, performanceAreas]);

  useEffect(() => {
    if (
      appUser &&
      (isFinalReviewer() || isAdministrator()) &&
      provider &&
      reviewers &&
      reviewers.length > 0 &&
      ![ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase(),ReviewStatusCode.ScoReviewCompleted.toLowerCase(),ReviewStatusCode.ScoSMEReview.toLowerCase()].includes(provider?.reviewStatusCode?.toLowerCase())
    ) {
      // get the final reviewer details
      const finalReview = reviewers.find(
        (r: any) =>
          r.reviewStatusCode?.toLowerCase() ===
          provider?.reviewStatusCode?.toLowerCase()
      );
      if (
        finalReview?.reviewState?.toLowerCase() !==
          ReviewState.NOTSTART?.toLowerCase()
      ) {
        calculate(true);
      }
    }
  }, [appUser, provider, reviewers]);

  useEffect(() => {
    if (provider?.providerId && isStatusLoaded) {
      handleRequiredStatusOption();
    }
  }, [provider?.providerId, provider?.reviewStatusCode, isStatusLoaded, allStatues, performanceAreas, isActiveDisputeReview]);

  const canHaveAccessToReview = (mpi: string) => {
    if (!mpi) {
      return;
    }
    httpService
      .get(`${ApiEndpoints.CanHaveAccessToReview}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        if (response.status === 200) {
          setCanReview(response.data);
        }
      })
      .catch((error: any) => {
        console.error("ScoProviderProfileComponent.canHaveAccessToReview failed", error);
      });
  };

  const getReviewersDetails = (mpi: string) => {
    if (!mpi) {
      return;
    }
    httpService
      .get(`${ApiEndpoints.GetReviewersDetailsByMpi}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        if (response.status === 200) {
          setReviewers(response.data);
        }
      })
      .catch((error: any) => {
        console.error("ScoProviderProfileComponent.getReviewersDetails failed", error);
      });
  };

  const fetchActivityLogs = useCallback(async (reviewer: StageReviewer): Promise<ReviewActivityLog[]> => {
    if (!provider?.mpi || !reviewYear || !reviewer.reviewStatusCode) return [];
    const response = await httpService.get<ReviewActivityLog[]>(
      `${ApiEndpoints.GetReviewActivityLogs}/${reviewYear}/${provider.mpi}/${reviewer.reviewStatusCode}`
    );
    return response.status === 200 && Array.isArray(response.data) ? response.data : [];
  }, [provider?.mpi, reviewYear]);

  const getProviderAdditionalInfo = (providerMpi: string) => {
    setProviderAdditionalInfo({});
    httpService
      .get(
        `${ApiEndpoints.GetProviderAdditionalInfo}/${reviewYear}/${providerMpi}`
      )
      .then((response: any) => {
        if (response.status === 200) {
          const info = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
          setProviderAdditionalInfo(info && typeof info === "object" && !Array.isArray(info) ? info : {});
        }
      })
      .catch(() => {
        toast.current?.show({ severity: "error", summary: "Error", detail: "Failed to load agency information.", life: 3000 });
      });
  };

  const fetchProviderContactDetails = (mpi: string) => {
    setProviderContactDetails({});
    httpService
      .get(`${ApiEndpoints.GetAgencyContactDetails}/${mpi}`)
      .then((response: any) => {
        if (response.status === 200) {
          setProviderContactDetails(response.data || {});
        }
      })
      .catch(() => {
        toast.current?.show({ severity: "error", summary: "Error", detail: "Failed to load primary contact information.", life: 3000 });
      });
  };

  const fetchAllCommentsForProviderLevel = (mpi: string) => {
    httpService
      .post(ApiEndpoints.GetAllComments, {
        commentLevel: "provider",
        providerMPI: mpi,
        measureId: 0,
        reviewYear,
        providerType: ProviderType.SCO,
      })
      .then((response: any) => {
        if (response.status === 200) {
          setAllProviderLevelCommentData(Array.isArray(response.data) ? response.data : []);
        }
      })
      .catch(() => setAllProviderLevelCommentData([]));
  };

  const openProviderComments = () => {
    setCommentProviderMPI(provider?.mpi || commentProviderMPI);
    setCommentLevel("provider");
    setCommentMeasureId(0);
    setCommentMeasureNumber("");
    setSidebarVisible(true);
  };

  const handleCommentsSidebarHide = () => {
    setSidebarVisible(false);
    setCommentMeasureId(0);
    setCommentMeasureNumber("");
    setCommentLevel("");
  };

  const updatePerformanceAreasForComments = (
    measureId: number,
    isCommentsLoaded: boolean = false
  ) => {
    const measures = performanceAreas.flatMap(area => area.standards.flatMap(standard => standard.measures));
    const hasMissingComments = measures.some(measure =>
      !measure.isCommentsAvailable && allCommentData.some(comment => comment.measureId === measure.measureId)
    );

    if (performanceAreas.length > 0 && measureId > 0) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === measureId) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true };
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    } else if (isCommentsLoaded && hasMissingComments) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (
                allCommentData.some((x) => x.measureId == measure.measureId)
              ) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true };
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };

  const isActiveReviewCycle = () => {
    httpService
      .get(`${ApiEndpoints.IsActiveReview}/${ProviderType.SCO}`)
      .then((response: any) => {
        setIsActiveReview(response?.data);
      })
      .catch((error: any) => {
        console.error("ScoProviderProfileComponent.isActiveReviewCycle failed", error);
      });
  };

  const isActiveDisputeReviewCycle = () => {
    httpService
      .get(`${ApiEndpoints.IsActiveDisputeCycle}/${ProviderType.SCO}`)
      .then((response: any) => {
        setIsActiveDisputeReview(response?.data);
      })
      .catch((error: any) => {
        console.error("ScoProviderProfileComponent.isActiveDisputeReviewCycle failed", error);
      });
  };

  const hasAnySMEReviewForMeasure = (): boolean => {
    return performanceAreas.some((area) =>
      area.standards.some((standard) =>
        standard.measures.some(
          (measure) =>
            measure.reviewResponse &&
            measure.reviewResponse?.toLowerCase() === "sme"
        )
      )
    );
  };
  const canDisableStatusRelatedInputs = useCallback(() => {
    const hasValidStatus =
      selectedStatus &&
      statusesByRole.some(
        (s) => s?.toLowerCase() == selectedStatus.statusCode?.toLowerCase()
      );
    return !canReview || canStartReview || !hasValidStatus;
  }, [selectedStatus, statusesByRole, canReview, canStartReview]);
  // Fetch files and provider details once provider is set

  const updateStatusDropDown = () => {
    let requiredStatuses: Status[];
    if (
      provider.reviewStatusCode?.toLowerCase() ===
        ReviewStatusCode.NotStarted?.toLowerCase() ||
      provider.reviewStatusCode?.toLowerCase() ===
        ReviewStatusCode.ScoNotStarted?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoNotStarted.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoInitialReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoInitialReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoInitialReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoSMEReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoSMEReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoFinalReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoFinalReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoReviewCompleted.toLowerCase()
      );
    } else {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
          ReviewStatusCode.ScoReviewCompleted.toLowerCase()
      );
    }
    // if (hasUnReviewedMeasures()) {
    //   requiredStatuses = requiredStatuses.filter(
    //     (s) => s.statusCode?.toLowerCase() !== ReviewStatusCode.ScoReviewCompleted.toLowerCase()
    //   );
    // }

    setStatus(requiredStatuses);
    return requiredStatuses;
  };

    const updateStatusDropDownForDispute = () => {
    let requiredStatuses: Status[];
    if (
      provider.reviewStatusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionNotStarted?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionNotStarted.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionInitialReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoResolutionInitialReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionInitialReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoResolutionSMEReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionSMEReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.ScoResolutionFinalReview?.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionFinalReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()
      );
    } else {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
          ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()
      );
    }
    // if (hasUnReviewedMeasures()) {
    //   requiredStatuses = requiredStatuses.filter(
    //     (s) => s.statusCode?.toLowerCase() !== ReviewStatusCode.ScoReviewCompleted.toLowerCase()
    //   );
    // }

    setStatus(requiredStatuses);
    return requiredStatuses;
  };
  const getAllStatus = () => {
    httpService
      .get<Status[]>(
        `${ApiEndpoints.GetStatus}?providerType=${Constants.SCOKey}`
      )
      .then((response) => {
        setAllStatues(response.data);
        setIsStatusLoaded(true);
      })
      .catch((error) => {
        console.error("ScoProviderProfileComponent.getAllStatus failed", error);
      });
  };

  const updateStatus = (e: Status) => {
    setUpdatingStatus(true); // Start loading
    httpService
      .post(ApiEndpoints.SetReviewStatus, {
        ProviderId: provider.providerId,
        StatusId: e.statusId,
        reviewerName: appUser?.name ?? appUser?.email,
        ReviewYear: reviewYear,
        MpiId: provider.mpi,
        providerType: ProviderType.SCO,
      })
      .then((response: any) => {
        if (response.status === 200) {
          setSelectedStatus(e);
          setChangingStatus(false);
          //setProviderDetails({ ...provider, reviewStatus: e.statusName })
          getReviewersDetails(provider.mpi);
          let currentReviewType =
            e.statusCode.toUpperCase() === ReviewStatusCode.InPrimaryReview
              ? ReviewType.PrimaryReview
              : e.statusCode.toUpperCase() === ReviewStatusCode.InPeerReview
              ? ReviewType.SecondaryReview
              : provider.reviewType;

          setSelectedProvider({
            ...provider,
            reviewStatusCode: e.statusCode,
            reviewStatus: e.statusName,
            reviewStatusId: e.statusId,
            reviewType: currentReviewType,
          });
          // Invoking ReviewStatusSync in Intake Portal - configurable via environment variable
          if (Constants.IS_REALTIME_REVIEW_STATUS_SYNC_ENABLED) {
            // syncReviewStatusInIntakePortal(e.statusId);
          }
          
          // Show success toast
          toast.current?.show({ 
            severity: 'success', 
            summary: 'Success', 
            detail: `Status updated to ${e.statusName} successfully`, 
            life: 3000 
          });
        }
      })
      .catch((error: any) => {
        console.error("Error updating status:", error);
        // Show error toast
        toast.current?.show({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Failed to update status. Please try again.', 
          life: 3000 
        });
      })
      .finally(() => {
        setUpdatingStatus(false); // Stop loading
      });
  };

  //flip to final review

  const changeStatusToFinalReview = () => {
    if (
      allStatues &&
      allStatues.length > 0 &&
      performanceAreas &&
      performanceAreas.length > 0
    ) {
      const requiredFinalStatus = isActiveDisputeReview?ReviewStatusCode.ScoResolutionFinalReview.toLowerCase():ReviewStatusCode.ScoFinalReview.toLowerCase()
      const finalReviewStatus = allStatues.find(
        (s) =>
          s.statusCode?.toLowerCase() ===
          requiredFinalStatus
      );
      if (!hasUnReviewedMeasures() && !hasAnySMEReviewForMeasure()) {
        if ((isSmeReviewer() || isAdministrator()) && finalReviewStatus && changingStatus) {
          if (
            provider && (isActiveDisputeReview && provider.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()) ||
            provider.reviewStatusCode?.toLowerCase() !==
              ReviewStatusCode.ScoFinalReview.toLowerCase()
          ) {
            // Ensure only one API call happens by checking and resetting changingStatus before calling updateStatus
            if (
              provider &&
              (isActiveDisputeReview && provider.reviewStatusCode?.toLowerCase() !==
              ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()) ||
              provider.reviewStatusCode?.toLowerCase() !==
              ReviewStatusCode.ScoFinalReview.toLowerCase() &&
              changingStatus
            ) {
              setChangingStatus(false); // Reset before API call to prevent duplicate calls
              updateStatus(finalReviewStatus);
            }
            setChangingStatus(false);
          }
        }
      }
    }
  };

  const setReviewStatus = (e: Status) => {
    const getStatusChangeAlertConfig = (e: any) => {
      let commonConfig = {
        open: true,
        title: "Confirm Status Change",
        message: `Are you sure you want to change the status to "${e.statusName}"?`,
        onClose: (result: boolean) => {
          if (result) {
            updateStatus(e);
          }
          dialogRef.current.setDialogConfig(undefined);
        },
      };

      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoSMEReview.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionSMEReview.toLowerCase()
      ) {
        if (hasUnReviewedMeasures()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: "Review Pending",
            message:
              "All measures must be reviewed before moving to SME Review.",
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }
      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoFinalReview.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionFinalReview.toLowerCase()
      ) {
        if (hasAnySMEReviewForMeasure()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: "SME Review Pending",
            message:
              "Some measures are pending SME review. You cannot move to Final Review until all SME reviews are completed.",
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }

        if (hasUnReviewedMeasures()) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: "Review Pending",
            message:
              "All measures must be reviewed before moving to Final Review.",
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }

      if (
        e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoReviewCompleted.toLowerCase() || e.statusCode?.toLowerCase() ===
        ReviewStatusCode.ScoResolutionReviewCompleted.toLowerCase()
      ) {
        if (
          hasUnReviewedMeasures() ||
          (!calculatedTier &&
            provider.currentTierCode?.toLowerCase() ===
              TierCode.UnAssigned.toLowerCase())
        ) {
          return {
            open: true,
            hideNo: true,
            yesButtonLabel: "Ok",
            title: hasUnReviewedMeasures()
              ? "Unreviewed Measures Present"
              : "Unassigned Tier",
            message: hasUnReviewedMeasures()
              ? "There are some unreviewed measures, so you cannot mark this as review complete."
              : `You cannot change the status to "${e.statusName}" while the provider is in the Unassigned tier.`,
            onClose: () => {
              dialogRef.current.setDialogConfig(undefined);
            },
          };
        }
      }
      return commonConfig;
    };

    if (dialogRef.current) {
      let config = getStatusChangeAlertConfig(e);
      dialogRef.current.setDialogConfig(config);
    }
  };

  // const syncReviewStatusInIntakePortal = (statusId: any) => {
  //   httpService
  //     .post(ApiEndpoints.SyncProviderStatusWithIntake, {
  //       ProviderId: provider.providerId,
  //       StatusId: statusId,
  //       reviewerEmail: appUser?.email ?? appUser?.name,
  //       MpiId: provider.mpi,
  //     })
  //     .then((response: any) => {
  //       if (response.status === 200) {
  //         console.log("allStatues:", allStatues);
  //         console.log("syncReviewStatusInIntakePortal Response:", response);
  //       }
  //     });
  // };

  // Fetch file information after file is uploaded
  useEffect(() => {
    if (fileUploaded) {
      //fetchSupportingFileInfo();
      setFileUploaded(false); // Reset after fetching
    }
  }, [fileUploaded]); // Triggers when a file is uploaded

  const fetchProviderDetails = async (mpiId: string) => {
    httpService
      .get(`${ApiEndpoints.GetProviderDetails}/${reviewYear}/${mpiId}`)
      .then((response: any) => {
        let _provider = response.data;
        setSelectedProvider(_provider);
        setSelectedStatus(getSelectedStatus(_provider.reviewStatus));
      })
      .catch((error: any) => {
      
        console.error("[ScoProviderProfileComponent] fetchProviderDetails failed", error);})
      .finally(() => {
        // console.log('Finally');
      });
  };

  const getSelectedStatus = (statusName: string) => {
    if (allStatues && allStatues.length > 0) {
      return (
        allStatues.find(
          (status) =>
            status.statusName?.toLowerCase() === statusName?.toLowerCase()
        ) || null
      );
    }
    return undefined;
  };

  const fetchAllCommentsForProvider = async (providerId: string) => {
    httpService
      .post(ApiEndpoints.GetAllCommentsForProvider, {
        commentLevel: commentLevel,
        providerMPI: providerId,
        measureId: commentMeasureId,
        reviewYear: reviewYear,
        providerType: ProviderType.SCO
      })
      .then((response: any) => {
        if (response.status === 200) {
          setAllCommentData(response?.data);
        }
      })
      .catch((error: any) => {
      
        console.error("[ScoProviderProfileComponent] fetchAllCommentsForProvider failed", error);})
      .finally(() => {
        // console.log('Finally');
      });
  };
  const updatePerformanceAreasStatus = (response: {
    reviewResponseId: number | null | undefined;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string | null;
    reasons: any[];
    userReason: string;
  }) => {
    if (performanceAreas.length > 0) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === response.measureId) {
                if (!response.questionId) {
                  // Update measure.isApproved
                  return {
                    ...measure,
                    reviewResponse: response.reviewResponse,
                    hasReasons:
                      (response.reasons && response.reasons.length > 0) ||
                      !!response.userReason,
                  };
                } else {
                  // Update question.isReviewed
                  return {
                    ...measure,
                    questions: measure.questions.map((question) =>
                      question.questionId === response.questionId
                        ? {
                            ...question,
                            reviewResponse: response.reviewResponse,
                          }
                        : question
                    ),
                  };
                }
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };

  // handling tier response submission
  const onReviewChange = (response: {
    reviewResponseId: number | null | undefined;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string;
    reasons: any[];
    userReason: string;
  }) => {
    const existingResponse = reviweResponses.find(
      (resp) =>
        resp.measureId === response.measureId &&
        resp.questionId === response.questionId
    );
    const updatedResponses = existingResponse
      ? reviweResponses.map((resp) =>
          resp === existingResponse
            ? {
                ...resp,
                reviewResponse: response.reviewResponse,
                reasons: response.reasons,
                userReason: response.userReason,
              }
            : resp
        )
      : [
          ...reviweResponses,
          {
            tierId: performanceAreas[0].standards[0].tierId,
            reviewResponseId: response.reviewResponseId,
            mpiId: provider.mpi,
            measureId: response.measureId,
            questionId: response.questionId,
            reviewResponse: response.reviewResponse,
            reasons: response.reasons,
            userReason: response.userReason,
          },
        ];
    updatePerformanceAreasStatus(response);
    setReviewResponses(updatedResponses);
    saveReviewResponses(updatedResponses);
  };

  const handleRequiredStatusOption = () => {
    let requiredStatuses = isActiveDisputeReview?updateStatusDropDownForDispute():updateStatusDropDown();
    const smeStatusCode = isActiveDisputeReview ?ReviewStatusCode.ScoResolutionSMEReview.toLowerCase():ReviewStatusCode.ScoSMEReview.toLowerCase();
    const hasSMEReview = hasAnySMEReviewForMeasure();

    if ([ReviewStatusCode.NotStarted, ReviewStatusCode.ScoNotStarted, ReviewStatusCode.ScoResolutionNotStarted].some(code => code.toLowerCase() === provider.reviewStatusCode?.toLowerCase())) {
      setStatus(requiredStatuses);
      return;
    }

    if (hasSMEReview) {
      if (
        !requiredStatuses.some(
          (s) => s.statusCode?.toLowerCase() === smeStatusCode
        )
      ) {
        const smeStatus = allStatues.find(
          (s) => s.statusCode?.toLowerCase() === smeStatusCode
        );
        if (smeStatus) requiredStatuses.push(smeStatus);
      }
    } else if (hasUnReviewedMeasures()) {
      requiredStatuses = requiredStatuses.filter(
        (s) =>
          s.statusCode?.toLowerCase() !==
            (isActiveDisputeReview ? ReviewStatusCode.ScoResolutionReviewCompleted : ReviewStatusCode.ScoReviewCompleted).toLowerCase()
      );
    } else {
      requiredStatuses = requiredStatuses.filter(
        (s) => s.statusCode?.toLowerCase() !== smeStatusCode
      );
    }

    setStatus(requiredStatuses);
  };

  const saveReviewResponses = (responses: ReviewRquest[] = reviweResponses) => {
    httpService
      .post(
        `${ApiEndpoints.SavePerformanceEvaluation}/${appliedTierId}/${provider.mpi}/${ProviderType.SCO}`,
        responses
      )
      .then((response) => {
        console.log("Review Response submitted successfully:", response);
        if (isSmeReviewer() || isAdministrator()) {
          setChangingStatus(true);
          getReviewersDetails(provider.mpi);
        }
        calculate(false);
      })
      .catch((error) => {
        console.error("Error submitting review response:", error);
      });
  };

  const calculate = (isOnload: boolean) => {
    if (
      provider?.reviewStatusCode?.toLowerCase() !==
      ReviewStatusCode.ScoReviewCompleted.toLowerCase() && provider?.reviewStatusCode?.toLowerCase() !==
        ReviewStatusCode.ScoSMEReview.toLowerCase()
    ) {
      if (
        (isFinalReviewer() || isAdministrator()) &&
        (isOnload ||
          (performanceAreas &&
            performanceAreas.length > 0 &&
            reviewers &&
            reviewers.length > 0))
      ) {
        const finalReview = reviewers.find(
          (r: any) =>
            r.reviewStatusCode?.toLowerCase() ===
            provider.reviewStatusCode?.toLowerCase()
        );
        if (
          !hasUnReviewedMeasures() &&
          finalReview &&
          finalReview.reviewState?.toLowerCase() !==
            ReviewState.NOTSTART?.toLowerCase()
        ) {
          setIsCalculate(true);
          calculateTier();
        }
      }
    } else {
      setIsCalculate(false);
    }
  };

  const calculateTier = () => {
    //if (reviweResponses.length > 0) {
    httpService
      .post(
        `${ApiEndpoints.SubmitPerformanceEvaluation}/${provider.providerId}/${appliedTierId}/${provider.mpi}?providerType=${Constants.SCOKey}`,
        reviweResponses
      )
      .then((response: any) => {
        console.log("response", response.data);
        setCalculatedTier(response.data);
        setIsCalculate(false);
      })
      .catch(() => {
        //if (dialogRef.current) {
        // dialogRef.current.setDialogConfig({
        //   open: true,
        //   title: "Tier Calculation Failed",
        //   message: "Error While calculating the Tier",
        //   hideNo: true,
        //   yesButtonLabel: "Ok",
        //   onClose: () => {
        //     dialogRef.current.setDialogConfig(undefined);
        //   },
        // });
        //}
        setIsCalculate(false);
        console.error("Error While calculating the Tier");
      });
  };

  const getFilenameFromContentDisposition = (contentDisposition: string) => {
    if (!contentDisposition) {
      return "";
    }
    const matches = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i
    );
    if (matches && matches[1]) {
      const decoded = decodeURIComponent(matches[1]);
      // Strip path separators and characters dangerous in HTML attributes;
      // control chars (charCode 0-31) removed via charCodeAt to avoid no-control-regex lint rule
      return decoded
        .replace(/[/\\?%*:|"<>]/g, "")
        .split("")
        .filter((c) => c.charCodeAt(0) > 31)
        .join("")
        .trim();
    }
    return "";
  };

  const downLoadProviderDataByDataSource = (dataSource: string) => {
    const safeMpi = String(provider.mpi ?? "");
    if (!/^\d+$/.test(safeMpi) || !/[1-9]/.test(safeMpi)) {
      console.error("Invalid MPI value");
      return;
    }
    httpService
      .getBlob(
        `${ApiEndpoints.ExtractDataByDataSource}/${safeMpi}/${encodeURIComponent(dataSource)}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition =
          response.headers["content-disposition"] ?? "";
        link.setAttribute(
          "download",
          getFilenameFromContentDisposition(contentDisposition)
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error: any) => {
        setShowConfirmDialog(true);
        console.error("Error downloading provider data:", error);
      });
  };

  // Fetch performance areas, standards, measures, questions, and documents
  const fetchPerformanceStandardsMeasuresInfo = async (
    mpiId: number,
    providerAppliedTier: string
  ) => {
    try {
      if (!mpiId || !providerAppliedTier) {
        setLoading(false);
        return;
      }
      setLoading(true);
      const performanceAreaUrl = isActiveDisputeReview?ApiEndpoints.GetAllPerformanceStandardsMeasuresDisputeInfo:ApiEndpoints.GetAllPerformanceStandardsMeasuresInfo
      const response = await httpService.get<PerformanceArea[]>(
        `${performanceAreaUrl}/${reviewYear}/${mpiId}?tierCode=${providerAppliedTier}`
      );
      let tierData = groupDataByTier(response.data);
      let activeTierData = tierData.filter(
        (tier) =>
          tier.tierCode?.toLowerCase() === providerAppliedTier?.toLowerCase()
      )[0];
      setPerformanceAreas(activeTierData?.performanceAreas || []);
      setAppliedTierId(activeTierData?.tierId || 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const groupDataByTier = (data: any[]): TierQuestions[] => {
    // Object.create(null) prevents prototype pollution via __proto__ / constructor keys
    const tierMap: { [key: number]: TierQuestions } = Object.create(null);
    data.forEach((item) => {
      const {
        tierId,
        tierName,
        tierCode,
        performanceAreaId,
        performanceAreaTitle,
        performanceAreaDescription,
        standardId,
        standardTitle,
        standardDescription,
        measureId,
        measureTitle,
        measureDescription,
        measureNumber,
        reviewResponse,
        hasReason,
        isReadOnly,
        reviewResponseId,
        isCalculatedField,
        questionId,
        questionTitle,
        questionDescription,
        isReviewed,
        fieldName,
        fieldValue,
        dataFieldType,
        dataSource,
        hasValidThreshold,
        questionSequence,
        questionNumber,
        propertySequence,
        displayConfig,
        recommendedStatus,
        comment,
        attachments,
        isEnabledForSme,
        isSmeInvolved
      } = item;

      // Validate tierId is a safe positive integer to prevent prototype pollution
      const safeTierId = Number(tierId);
      if (!Number.isFinite(safeTierId) || !Number.isInteger(safeTierId) || safeTierId <= 0) return;

      // If the tier doesn't exist, create it
      if (!tierMap[safeTierId]) {
        tierMap[safeTierId] = {
          tierId: safeTierId,
          tierName,
          tierCode,
          performanceAreas: [],
        };
      }
      //
      // Add performance area to the tier
      if (!tierMap[safeTierId].performanceAreas) {
        tierMap[safeTierId].performanceAreas = [];
      }

      let performanceArea = tierMap[safeTierId].performanceAreas.find(
        (pa) => pa.performanceAreaId === performanceAreaId
      );
      if (!performanceArea) {
        performanceArea = {
          performanceAreaId,
          performanceAreaTitle,
          performanceAreaDescription,
          standards: [],
        };
        tierMap[safeTierId].performanceAreas.push(performanceArea);
      }

      // Add standard to the performance area
      let standard = performanceArea.standards.find(
        (s) => s.standardId === standardId
      );
      if (!standard) {
        standard = {
          standardId,
          standardTitle,
          standardDescription,
          isLocationSpecific: item.isLocationSpecific,
          tierId: safeTierId,
          tierName,
          measures: [],
        };
        performanceArea.standards.push(standard);
      }

      // Add measure to the standard
      let measure = standard.measures.find((m) => m.measureId == measureId);
      if (!measure) {
        const commentAvailable =
          allCommentData.filter((c) => c.measureId === measureId).length > 0;
        measure = {
          measureId,
          measureTitle,
          measureDescription,
          measureNumber,
          reviewResponse,
          hasReasons: hasReason,
          isReadOnly:isReadOnly,
          reviewResponseId: reviewResponse ? reviewResponseId : null,
          questions: [],
          isCommentsAvailable: commentAvailable,
          recommendedStatus,
          isEnabledForSme: isEnabledForSme === true, // Set initially if present in this row
          isSmeInvolved: isSmeInvolved === true
        };
        standard.measures.push(measure);
      }
      // If any question for this measure has isEnabledForSme true, set it at measure level
      if (isEnabledForSme === true) {
        measure.isEnabledForSme = true;
      }
      // If any question for this measure has isSmeInvolved true, set it at measure level
      if (isSmeInvolved === true) {
        measure.isSmeInvolved = true;
      }

      let question = measure.questions.find((q) => q.questionId === questionId);
      if (!question) {
        question = {
          questionId,
          questionTitle,
          questionDescription,
          questionSequence: questionSequence,
          questionNumber: questionNumber,
          dataFieldType,
          isReviewed,
          dataSource,
          reviewResponseId: isReviewed ? reviewResponseId : null,
          isCalculatedField,
          comment,
          attachments:attachments?JSON.parse(attachments):attachments,
          displayConfig: displayConfig
            ? JSON.parse(displayConfig)
            : displayConfig,
          responseData: [],
        };

        measure.questions.push(question);
      }

      question.responseData.push({
        fieldName,
        fieldValue,
        hasValidThreshold,
        propertySequence,
      });
    });
    return Object.values(tierMap);
  };

  const canDisable = useCallback(() => {
    return (
      //isAdministrator() ||
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.NotStarted?.toLowerCase() ||
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoNotStarted?.toLowerCase() ||
      provider?.reviewStatusId == 0 ||
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoReviewCompleted?.toLowerCase() ||
         selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoResolutionReviewCompleted?.toLowerCase() ||
        selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ScoResolutionNotStarted?.toLowerCase() ||
      canDisableStatusRelatedInputs()
    );
  }, [selectedStatus, provider?.reviewStatusId, canDisableStatusRelatedInputs]);

  const hasUnReviewedMeasures = (): boolean => {
    const hasunreviewedMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter(
              (measure) =>
                isUnreviewed(measure.reviewResponse)
            ).length
          );
        }, 0)
      );
    }, 0);
    return hasunreviewedMeasures > 0;
  };

  const isUnreviewed = (response: string | null | undefined) => {
    return !response?.trim() || ["null", "nr"].includes(response.trim().toLowerCase());
  };

  const renderStandardsSection = (standards: Standard[]) => {
    return (
      <>
        {[...(standards || [])]
          .sort((a, b) => a?.standardTitle.localeCompare(b?.standardTitle))
          .map((standard: Standard) => (
            <StandardsDetailsComponent
              downLoadProviderDataByDataSource={
                downLoadProviderDataByDataSource
              }
              key={`${standard.standardId}-${isActiveReview && !canDisable()}`}
              isEnabled={isActiveReview && !canDisable()}
              standard={standard}
              dialogRef={dialogRef}
              onReviewChange={onReviewChange}
              updatePerformanceAreasForComments={
                updatePerformanceAreasForComments
              }
              providerAgencyName={provider?.providerAgencyName}
              evaluationStatuses={[...measureEvaluationStatuses]}
              mpi={provider?.mpi}
              canDisableDropdown={(isActiveDisputeReview && !hasDisputeQuestion([standard]))}
              CanShowDisputeIcon={(isActiveDisputeReview && hasDisputeQuestion([standard]))}
              isActiveDisputeReview={isActiveDisputeReview}
              isActiveReview={isActiveReview}
              reviewStatusCode={provider?.reviewStatusCode}
              reviewYear={reviewYear}
              providerType={ProviderType.SCO}
            />
          ))}
      </>
    );
  };

  const getPAEvaluationStatusCounts = (area: PerformanceArea) => {
    const statuses = [
      ...measureEvaluationStatuses.filter(status => status.code === "nr"),
      ...measureEvaluationStatuses.filter(status => status.code !== "nr"),
    ];

    let counts = statuses
      .filter((s) => s.canShowStatus)
      .map((status) => {
        return {
          ...status,
          count: area.standards.reduce((acc, standard) => {
            return (
              acc +
              standard.measures.filter((measure) => {
                if (status.code === "null" || status.code?.toLowerCase() === "nr") {
                  return (
                    measure.reviewResponse === null ||
                    measure.reviewResponse === undefined ||
                    measure.reviewResponse === "" ||
                    (typeof measure.reviewResponse === "string" &&
                      (
                        measure.reviewResponse?.trim().toLowerCase() === "null"
                        || measure.reviewResponse?.trim().toLowerCase() === "nr"
                    ))
                  );
                }
                return (
                  measure.reviewResponse &&
                  measure.reviewResponse?.toLowerCase() ===
                    status.code?.toLowerCase()
                );
              }).length
            );
          }, 0),
        };
      });
    // Total measures per status (not used for display, just for total count)
    const totalMeasuresCount = area.standards.reduce(
      (acc, standard) => acc + standard.measures.length,
      0
    );

    return (
      <span style={{ marginLeft: 8 }}>
        {counts.filter(status => status.code === "nr" || status.code === "sme").map((status) => (
          <Badge
            key={status.code}
            value={
              status.code === "nr"
                ? `Unreviewed Measures: ${status.count}`
                : `SME Review Measures: ${status.count} / ${totalMeasuresCount}`
            }
            severity={status.code === "nr" ? "danger" : "warning"}
            className="ml-2"
          />
        ))}
      </span>
    );
  };

  const perfromanceAreaTabHeader = (area: PerformanceArea) => {
    const getIsCommentAvailable = (standards: Standard[]): boolean => {
      let isComments: boolean = false;
      standards.forEach((std) =>
        std.measures.forEach((measure) => {
          if (measure.isCommentsAvailable) {
            isComments = true;
          }
        })
      );
      return isComments;
    };


const hasJustificationReasons = (standards: Standard[]): boolean => {
      let hasReasons: boolean = false;
      standards.forEach((std) =>
        std.measures.forEach((measure) => {
          if ( measure.reviewResponse?.toLowerCase() === "na") {
            hasReasons = true;
            return hasReasons
          }
        })
      );
      return hasReasons;
    };
    return (
      <div className="d-flex">
        <div
          className="d-flex"
          style={{ flexGrow: "1", justifyContent: "space-between" }}
        >
          <Tooltip target={"#pa-" + area.performanceAreaId} className="pbc-profile-tooltip" />
          <div
            data-pr-tooltip={area.performanceAreaTitle}
            data-pr-position="left"
            data-pr-at="right top-20"
            data-pr-my="center"
            id={area.performanceAreaId.toString()}
            className={""}
          >
            <div
              style={{
                display: "inline-block",
                maxWidth: "100ch",
                lineHeight: "2",
                textOverflow: "ellipsis",
              }}
            >
              {area.performanceAreaTitle}
              {": "}
              {area.performanceAreaDescription}
            </div>
            <span style={{ marginLeft: 8 }}>
              {hasDisputeQuestion(area.standards) ? (
                <ProviderProfileTooltip content="Dispute Performance Area">
                  <i
                    className="pi pi-flag-fill"
                    style={{ width: "20px", paddingTop: "5px", color: 'red', fontSize: '1.2rem' }}
                  ></i>
                </ProviderProfileTooltip>
              ) : ""}
            </span>
          </div>
          {getPAEvaluationStatusCounts(area)}
        </div>
        <div>
          {hasJustificationReasons(area.standards) ? (
            <ProviderProfileTooltip content="Fail Reason">
              <i
                className="pi pi-comments measure-not-approved-icon"
                style={{ width: "20px", paddingTop: "5px" }}
              ></i>
            </ProviderProfileTooltip>
          ) :""}
        </div>
        <div>
          {getIsCommentAvailable(area.standards) ? (
            <ProviderProfileTooltip content="Comments" position="bottom">
              <i
                className={"pi pi-comments"}
                style={{ width: "20px", paddingTop: "5px" }}
              ></i>
            </ProviderProfileTooltip>
          ) : (
            <i className="pi" style={{ width: "20px", paddingTop: "5px" }}></i>
          )}
        </div>
      </div>
    );
  };

  const hasDisputeQuestion = (standards: Standard[]) => {
    let hasDisputeRaised: boolean = false;
    hasDisputeRaised = standards.some(
      s => s.measures.some(
        m => m.questions.some(
          q => !!q.comment || (Array.isArray(q.attachments) && q.attachments.length > 0)
        )
      )
    );
    return hasDisputeRaised;
  }
  const getTotalMeasures = () => {
    const totalMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return acc + standard.measures.length;
        }, 0)
      );
    }, 0);
    return totalMeasures;
  };

  const getCountByStatus = (statusCode: string) => {
    return performanceAreas
      .flatMap((area) =>
        area.standards.flatMap((standard) => standard.measures)
      )
      .filter((measure) => {
        if (statusCode === "null" || statusCode === "nr") {
          return isUnreviewed(measure.reviewResponse);
        }
        return (
          measure.reviewResponse?.toLowerCase() === statusCode.toLowerCase()
        );
      }).length;
  };

  const renderEvaluationStatusByReview = () => {
    const pills: { code: string; label: string; severity: "danger" | "success" | "warning" }[] = [
      { code: "nr", label: "Unreviewed Measures", severity: "danger" },
      { code: "a", label: "Approved Measures", severity: "success" },
      { code: "sme", label: "SME Review Measures", severity: "warning" },
    ];
    const totalMeasures = getTotalMeasures();

    return (
      <div>
        {pills
          .filter(pill => measureEvaluationStatuses.some(status => status.code === pill.code && status.canShowStatus))
          .map(pill => (
            <Badge
              key={pill.code}
              value={`${pill.label}: ${getCountByStatus(pill.code)} / ${totalMeasures}`}
              severity={pill.severity}
              style={{ fontWeight: 600 }}
              className="ml-2"
            />
          ))}
      </div>
    );
  };

  // Main Accordion for Performance Areas
  const renderPerformanceAreasAccordion = () => {
    return (
      <>
        <div>
          <div className="evaluation-info-container">
            <h3>
              <span className="section-title">Performance Evaluation</span>

            </h3>

            {renderEvaluationStatusByReview()}
          </div>
          <Accordion>
            {[...performanceAreas]
              .sort((a, b) =>
                alphaNumericSort(
                  a.performanceAreaTitle,
                  b?.performanceAreaTitle
                )
              )
              .map((area) => (
                <AccordionTab
                  key={area.performanceAreaTitle}
                  header={perfromanceAreaTabHeader(area)}
                  headerClassName={hasDisputeQuestion(area.standards) ? 'dispute-accordion-header' : ''}
                >
                  {renderStandardsSection(area.standards)}
                </AccordionTab>
              ))}
          </Accordion>
        </div>
      </>
    );
  };

  // Callback function for successful file upload
  const handleUploadSuccess = () => {
    setUploadStatus("File uploaded successfully");
    setFileUploaded(true); // Trigger file upload state change
  };

  const renderTierView = () => {
    return (
      <div className="tier-view-accordion">
        {loading ? (
          <p>Loading performance areas...</p>
        ) : (
          renderPerformanceAreasAccordion()
        )}
      </div>
    );
  };

  const downloadDataFile = (fileName: any, providerId: any) => {
    const safeProviderId = Number(providerId);
    if (!safeProviderId || !Number.isInteger(safeProviderId) || safeProviderId <= 0) {
      return;
    }
    httpService
      .get(
        `${ApiEndpoints.DownloadSupportingDataFile}/${safeProviderId}/${encodeURIComponent(String(fileName))}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        if (response) {
          let url = response.data.url;
          const validatedUrl = new URL(url);
          if (
            validatedUrl.protocol === "http:" ||
            validatedUrl.protocol === "https:"
          ) {
            const anchor = document.createElement("a");
            anchor.href = validatedUrl.toString();
            anchor.target = "_blank";
            anchor.click();
          }
        }
      })
      .catch((error: any) => {
        
        console.error("[ScoProviderProfileComponent] downloadDataFile failed", error);setShowConfirmDialog(true);
      })
      .finally(() => {
        //setShowConfirmDialog(false);
      });
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const hideDialog = () => {
    setShowConfirmDialog(false);
  };
  const StartReview = () => {
    httpService
      .get(`${ApiEndpoints.StartReview}/${reviewYear}/${provider.mpi}`)
      .then((response: any) => {
        if (response) {
          setCanStartReview(false);
          getReviewersDetails(provider.mpi);
        }
      })
      .catch((error: any) => {
      
        console.error("[ScoProviderProfileComponent] StartReview failed", error);});
  };
  const currentStatusCode = (selectedStatus?.statusCode || provider?.reviewStatusCode || "").toLowerCase();
  const isSMEReviewStage = [ReviewStatusCode.ScoSMEReview, ReviewStatusCode.ScoResolutionSMEReview]
    .some(code => code.toLowerCase() === currentStatusCode);
  const isReviewCompleted = [ReviewStatusCode.ScoReviewCompleted, ReviewStatusCode.ScoResolutionReviewCompleted]
    .some(code => code.toLowerCase() === currentStatusCode);
  const isFinalReviewStage = isReviewCompleted || [ReviewStatusCode.ScoFinalReview, ReviewStatusCode.ScoResolutionFinalReview]
    .some(code => code.toLowerCase() === currentStatusCode);
  const hasStageTracker = isSMEReviewStage || isFinalReviewStage;
  const isPendingSmeMeasure = (measure: Standard["measures"][number]) =>
    measure.reviewResponse?.trim().toLowerCase() === "sme" &&
    (!isSmeReviewer() || measure.isEnabledForSme === true);
  const pendingMeasuresCount = performanceAreas.reduce((total, area) => total + area.standards.reduce(
    (count, standard) => count + standard.measures.filter(isPendingSmeMeasure).length, 0
  ), 0);
  const performanceAreasRemaining = performanceAreas.filter(area =>
    area.standards.some(standard => standard.measures.some(isPendingSmeMeasure))
  ).length;

  return (
    <div className="provider-profile-file-upload pbc-provider-profile">
      {provider && (
        <>
          <div className="profile-top-actions">
            {allProviderLevelCommentData.length > 0 && (
              <Button
                icon={<ProviderCommentIcon />}
                className="p-button-text profile-icon-btn profile-icon-btn--comment-add"
                aria-label="View or add provider comments"
                tooltip="View or add comments"
                tooltipOptions={{ className: "pbc-profile-tooltip", event: "both", position: "bottom" }}
                onClick={openProviderComments}
              />
            )}
            <Button
              className="p-button-text profile-comment-btn"
              disabled={!isActiveReview}
              onClick={openProviderComments}
              label="Comment"
            />
          </div>
          <div className="profile-card">
            <div className="profile-card-title">Agency Information</div>
            <div className="profile-info-table-wrapper">
              <table className="profile-info-table" aria-label="Agency Information">
                <thead>
                  <tr>
                    <th scope="col">Agency Name</th>
                    <th scope="col">Agency MPI</th>
                    {Object.keys(providerAdditionalInfo).map(key => (
                      <th scope="col" key={key}>{key}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
              {provider?.providerAgencyName?.length > 40 ? (
                <>
                  <span
                    className="agency-name-ellipsis"
                    data-pr-tooltip={provider?.providerAgencyName}
                  >
                    {provider?.providerAgencyName}
                  </span>
                  <Tooltip target=".agency-name-ellipsis" className="pbc-profile-tooltip" />
                </>
              ) : (
                provider?.providerAgencyName
              )}
                    </td>
                    <td>{provider.mpi}</td>
                    {Object.keys(providerAdditionalInfo).map(key => (
                      <td key={key}>{providerAdditionalInfo[key]}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="profile-card-divider" />
            <div className="profile-card-title">Primary Contact Information</div>
            <DataTable value={[providerContactDetails]} paginator={false} className="primary-contact">
              <Column field="primaryContactFirstName" header="First Name" />
              <Column field="primaryContactLastName" header="Last Name" />
              <Column field="primaryContactPhone" header="Phone Number" />
              <Column
                field="primaryContactEmail"
                header="Email Address"
                body={(rowData: { primaryContactEmail?: string }) =>
                  rowData.primaryContactEmail && rowData.primaryContactEmail !== "-" ? (
                    <a
                      href="#"
                      onClick={(event) => {
                        event.preventDefault();
                        setEmailDialogVisible(true);
                      }}
                    >
                      {rowData.primaryContactEmail}
                    </a>
                  ) : "-"
                }
              />
            </DataTable>
          </div>
          <div className={`review-stage-section${hasStageTracker ? "" : " review-stage-section--full"}`}>
            <div className="review-stage-left">
              <div className="review-status-strip">
              <label className="review-status-label" id="sco-review-status_label" htmlFor="sco-review-status">Review Status:</label>
              {status.length > 0 && (
                <Dropdown
                  inputId="sco-review-status"
                  aria-labelledby="sco-review-status_label"
                  className="review-status-dropdown"
                  disabled={
                    updatingStatus ||
                    !isActiveReview ||
                     (isAdministrator() && (
                        selectedStatus?.statusCode?.toLowerCase() === ReviewStatusCode.ScoReviewCompleted?.toLowerCase() ||
                        selectedStatus?.statusCode?.toLowerCase() === ReviewStatusCode.ScoResolutionReviewCompleted?.toLowerCase()
                      )) ||
                    canDisableStatusRelatedInputs()
                  }
                  value={selectedStatus}
                  onChange={(e: DropdownChangeEvent) =>
                    setReviewStatus(e.value)
                  }
                  options={[...status].sort((a, b) =>
                    a.statusName.localeCompare(b.statusName)
                  )}
                  optionLabel="statusName"
                  placeholder={provider.reviewStatus}
                />
              )}
              {updatingStatus && (
                <i 
                  className="pi pi-spin pi-spinner" 
                  style={{ fontSize: '1.2em', marginLeft: '8px' }}
                ></i>
              )}
              {canStartReview && status.length > 0 && (
                <Button
                  label={hasStageTracker ? "Start" : "Start Review"}
                  className={hasStageTracker ? "start-button" : "ml-2"}
                  onClick={() => StartReview()}
                />
              )}
              {isFinalReviewStage && (
                <div className="tier-determination-group">
                  <span className="review-status-label">Outcome Status:</span>
                  <div className="tier-determination-box" role="status" aria-live="polite">
                    {(isFinalReviewer() || isAdministrator()) && isCalculate ? (
                      <>
                        <i className="pi pi-spin pi-spinner" aria-hidden="true" />
                        <span> Calculating...</span>
                      </>
                    ) : (
                      calculatedTier || provider.currentTier || "-"
                    )}
                  </div>
                </div>
              )}
              </div>
              {isSMEReviewStage && (
                <SmeReviewStatsComponent
                  pendingMeasuresCount={pendingMeasuresCount}
                  performanceAreasRemaining={performanceAreasRemaining}
                />
              )}
            </div>
            {hasStageTracker && (
              <ReviewStageTrackerComponent
                reviewers={reviewers}
                title="Review Stage Tracker"
                subtitle="Click on each status to view user activity log"
                fetchActivityLogs={fetchActivityLogs}
                activityLogClassName="sco-activity-log-dialog"
                defaultFallback="N/A"
              />
            )}
          </div>
        </>
      )}
      <Dialog
        header="Upload"
        visible={visible}
        onHide={() => setVisible(false)}
      >
        <div
          className="flex flex-column px-8 py-5 gap-4"
          style={{
            borderRadius: "12px",
            width: "1000px",
            height: "auto",
            minHeight: "300px",
          }}
        >
          {provider.providerId && (
            <MultipartFileUploadComponent
              name="file"
              customUpload
              accept=".pdf,.doc,.docx"
              maxFileSize={1000000}
              auto
              chooseLabel="Choose"
              uploadLabel="Upload"
              cancelLabel="Cancel"
              className="p-mb-3"
              onFileuploaded={() => {
                console.log("file uploaded");
                // Refresh provider details to show the uploaded file immediately
                if (provider?.mpi && (provider?.appliedTierCode || provider?.currentTierCode)) {
                  fetchPerformanceStandardsMeasuresInfo(
                  provider.mpi,
                  provider.appliedTierCode || provider.currentTierCode
                  );
                }
              }}
              providerId={provider.mpi}
              providerProfile="ProviderProfile"
              onUpload={handleUploadSuccess}
              onError={() => {
                setUploadStatus("Upload failed. Please try again.");
              }}
            />
          )}
          {uploadStatus && <p>{uploadStatus}</p>}
        </div>
      </Dialog>

      {provider.attestationFile ? (
        <div className="attestation-button-wrapper">
          <Button
            onClick={() => {
              downloadDataFile(provider.attestationFile, provider?.mpi);
            }}
            icon="pi pi-download"
            className="p-button-secondary"
          >
            &nbsp;{provider.attestationFile}
            {/*"Download Attestation File"*/}
          </Button>
        </div>
      ) : (
        <></>
      )}

      <div>{renderTierView()}</div>
      <Dialog
        header="File not found!"
        visible={showConfirmDialog}
        onHide={hideDialog}
        footer={
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              label="Close"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideDialog}
              autoFocus
            />
          </div>
        }
      >
        <div>
          <p>{Constants.FILE_NOT_FOUND_ERROR}</p>
        </div>
      </Dialog>
      {sidebarVisible && (
        <CommentsSidebar
          {...{
            sidebarVisible,
            handleCommentsSidebarHide,
            commentProviderMPI,
            commentMeasureId,
            commentMeasureNumber,
            commentLevel,
            updatePerformanceAreasForComments,
            providerAgencyName: provider?.providerAgencyName,
            externalSave: () => {
              if (commentProviderMPI) {
                void fetchAllCommentsForProvider(commentProviderMPI);
                fetchAllCommentsForProviderLevel(commentProviderMPI);
              }
            },
            providerType: ProviderType.SCO
          }}
        />
      )}
      <CommonDialogWindowComponent ref={dialogRef} />
      <SendEmailDialogComponent
        visible={emailDialogVisible}
        onHide={() => setEmailDialogVisible(false)}
        providerInfo={{
          agencyName: provider?.providerAgencyName,
          mpi: provider?.mpi,
          primaryContactFirstName: providerContactDetails?.primaryContactFirstName,
          primaryContactLastName: providerContactDetails?.primaryContactLastName,
          primaryContactEmail: providerContactDetails?.primaryContactEmail,
        }}
      />
      <Toast ref={toast} />
    </div>
  );
};

export default ScoProviderProfileComponent;
